// extracted by mini-css-extract-plugin
export default {"tab":"Tabs_tab__1-hjk","active":"Tabs_active__fImDE"};